import React, { useEffect, useState, useRef } from 'react';
import withStyles from 'react-jss';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getTenantState } from '../../store/selectors';
import Chevron from '../user-dashboard/utility/Chevron';

const hoverOverFilterOptionStyles = {
  color: (props) => ({
    '&:hover': {
      backgroundColor: '#ededed',
      color: props.color,
      cursor: 'pointer',
    },
  }),
};

function AcademicProgramCategoryFilter(props) {
  const { t } = useTranslation();
  const [selectedCategories, setSelectedCategories] = useState(
    props.educationLevel === 'Bachelor’s degree' ||
      props.educationLevel === 'Some graduate courses' ||
      props.educationLevel ===
        "Master's degree or two-year graduate credential" ||
      props.educationLevel ===
        'Doctorate degree or four-year graduate credential'
      ? ['Graduate Degrees', 'Graduate Certificates']
      : ['Undergraduate Degrees', 'Certificates']
  );
  const [showDropdown, setShowDropdown] = useState(false);
  const [chevronTransform, setChevronTransform] = useState('rotate(90deg)');

  const divFilter = useRef();

  const categories = [
    'View All',
    'Undergraduate Degrees',
    'Graduate Degrees',
    'Certificates',
    'Graduate Certificates',
  ];
  const toggleShowDropdown = (toShow = false) => {
    if (toShow) {
      setShowDropdown(true);
      setChevronTransform('rotate(270deg)');
    } else {
      setShowDropdown(false);
      setChevronTransform('rotate(90deg)');
    }
  };

  const handleClickOutsideFilter = (event) => {
    if (!(divFilter && divFilter.current)) return;

    if (!divFilter.current.contains(event.target)) {
      toggleShowDropdown(false);
    }
  };

  const handleCheck = (category) => {
    if (selectedCategories.includes('View All')) {
      setSelectedCategories([category]);
    } else if (category === 'View All') {
      setSelectedCategories(['View All']);
    } else if (!selectedCategories.includes(category)) {
      setSelectedCategories([...selectedCategories, category]);
    } else if (selectedCategories.length === 1) {
      setSelectedCategories(['View All']);
    } else {
      setSelectedCategories(
        selectedCategories.filter((selectedCategory) => {
          return selectedCategory !== category;
        })
      );
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutsideFilter);

    return () => {
      window.removeEventListener('mousedown', handleClickOutsideFilter);
    };
  });

  // Send the selected category back to the parent component
  useEffect(() => {
    props.setSelectedAcademicProgramCategories(selectedCategories);
  }, [selectedCategories]);

  return (
    <div className="academic-program-category-filter" ref={divFilter}>
      <div className="academic-program-category-filter__header">
        {t('Filter by:')}
      </div>
      <div
        className="academic-program-category-filter__button"
        onClick={() => toggleShowDropdown(!showDropdown)}
        onKeyDown={(e) => {
          if (['Enter'].includes(e.key)) toggleShowDropdown(!showDropdown);
        }}
        role="button"
        tabIndex={0}
        aria-label={`Click to ${
          showDropdown ? 'close' : 'open'
        } the academic program category filter dropdown. Currently selected: ${selectedCategories.join(
          ', '
        )}`}
      >
        <div className="academic-program-category-filter__subheader">
          {selectedCategories.join(', ')}
        </div>
        <div className="academic-program-category-filter__subheader-chevron">
          <Chevron transform={chevronTransform} />
        </div>
      </div>

      {showDropdown && (
        <div className="academic-program-category-filter__dropdown">
          {categories.map((category) => {
            return (
              <div
                className={[
                  'academic-program-category-filter__option',
                  props.classes.color,
                ].join(' ')}
                key={category}
                onClick={() => handleCheck(category)}
                onKeyDown={(e) => {
                  if (['Enter'].includes(e.key)) handleCheck(category);
                }}
                role="menuitem"
                tabIndex={-1}
              >
                <div className="academic-program-category-filter__checkbox-container">
                  <input
                    type="checkbox"
                    value
                    tabIndex={0}
                    checked={selectedCategories.includes(category)}
                    onChange={() => handleCheck(category)}
                    className="custom-checkbox"
                    style={
                      ({ border: '1px solid #555555' }, { color: props.color })
                    }
                    aria-label={`Check to filter degrees by ${category}.`}
                  />
                  <label className="academic-program-category-filter__option-label">
                    {category}
                  </label>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (state) => ({
  tenant: getTenantState(state),
});

export default withStyles(hoverOverFilterOptionStyles)(
  connect(mapStateToProps, {})(AcademicProgramCategoryFilter)
);
